<template>
  <div
    class="h-8 w-8 flex justify-center items-center rounded-full bg-gray-900 text-white border border-white-900"
    :title="name"
  >
    <div>
      {{ initials }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Avatar",
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    // TODO - TEST WITH DIFFERENT NAMES/MORE CHARACTERS
    initials() {
      return this.name
        .split(" ")
        .map((part) => part.charAt(0).toUpperCase())
        .join("");
    },
  },
};
</script>
